__turbopack_context__.v({
  "buttonBarItem": "QwF2VG_buttonBarItem",
  "text": "QwF2VG_text",
  "wrapper": "QwF2VG_wrapper",
});
